export default __webpack_public_path__ + "static/media/products_214.7ee70e79.jpg";